import React, { Component } from 'react';
import { Col, notification, Row } from 'antd';
import { connect } from 'react-redux';
import { dispatch, IRootDispatch, IRootState, state } from 'stores/rematch/root-store';
import { Paragraph } from 'common-components/typography';
import SpinningLoadingActionModel from 'common-components/loading/SpinningLoadingActionModel';
import ActionModal from 'common-components/modal/ActionModal';
import { GhostButton, PrimaryButton } from 'common-components/buttons';
import { DebtorType } from 'utilities/enum-utils';

interface IRemoveSelfManagerModalProps {
  closeRemoveSelfManagerModal: () => void;
  isOpen: boolean;
  selectedCustomer: typeof state.customersStore.selectedCustomer;
  doRemoveCustomerDebtor: typeof dispatch.customersStore.doRemoveCustomerDebtor;
}

class RemoveSelfManagerModal extends Component<IRemoveSelfManagerModalProps> {
  state = { isLoading: false, title: 'Remove self manager', step: 1 };

  private _removeSelfManager = async () => {
    const { doRemoveCustomerDebtor, selectedCustomer } = this.props;
    try {
      this.setState({
        isLoading: true,
      });

      await doRemoveCustomerDebtor({
        customerUserId: selectedCustomer.userId,
        debtorType: DebtorType.SELF,
        debtorId: selectedCustomer.selfManager.debtorId,
      });

      this.setState({
        isLoading: false,
        title: <>Self manager successfully removed</>,
        step: 2,
      });
    } catch (e) {
      notification.error({ message: 'Oops, an error has occurred, please try again.' });
    }
  };

  private _closeModal = () => {
    this.setState({ title: 'Remove self manager', step: 1 });
    this.props.closeRemoveSelfManagerModal();
  };

  render() {
    const { step } = this.state;
    return (
      <div>
        <ActionModal title={this.state.title} isOpen={this.props.isOpen} onClose={this._closeModal} width="medium">
          {step === 1 && (
            <div className="anim-slide-left">
              <SpinningLoadingActionModel isOpen={this.state.isLoading} verticalAlignment={'highest'} />
              <Paragraph>Are you sure you want to remove this self manager from this customer profile?</Paragraph>
              <div className={'mb-small mt-x2-large'}>
                <Row type={'flex'} className={'justify-end'}>
                  <Col className="mr-large">
                    <GhostButton size="large" onClick={this.props.closeRemoveSelfManagerModal}>
                      Cancel
                    </GhostButton>
                  </Col>
                  <Col>
                    <PrimaryButton size="large" color="red" onClick={this._removeSelfManager}>
                      Remove
                    </PrimaryButton>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          {step === 2 && (
            <div className="anim-slide-left">
              <Paragraph>You have successfully removed this self manager from the customer profile.</Paragraph>
              <div className={'mb-small mt-x2-large'}>
                <Row type={'flex'} className={'justify-end'}>
                  <Col>
                    <PrimaryButton size="large" onClick={this._closeModal}>
                      Close
                    </PrimaryButton>
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </ActionModal>
      </div>
    );
  }
}

const mapState = (state: IRootState) => ({
  selectedCustomer: state.customersStore.selectedCustomer,
});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doRemoveCustomerDebtor: dispatch.customersStore.doRemoveCustomerDebtor,
});

export default connect(mapState, mapDispatch)(RemoveSelfManagerModal);
